import { AccessTime, AttachFile, CalendarMonth, Delete, Print } from '@mui/icons-material'
import moment from 'moment'
import React from 'react'
import useUserList from '../../../hooks/useUserList';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const JsonViewer = ({jsonData}) =>{
    const jt = JSON.parse(jsonData);
    return(
        <>
            {jt.length> 0 &&
            <table className="table p-0 m-0" >
                <thead>
                    <tr className='text-center table-info'>
                        <th colSpan={2}>Details</th>
                    </tr>
                </thead>
                <tbody>
                    {jt.map(data=>
                        <tr>
                            <th>{data.label}</th>
                            <td>{data.value}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            }
        </>
    )
}

function DocumentTimeline({activityList,callback}) {

    const {authUser } = useAuth();
    const {getUserName} = useUserList();

    const removeActivityData = (activity,id) => {

    }

    return (
        <div className='mt-4'>
            {activityList && activityList.map(r=>
                <div className="timeline-item mb-3" key={r.id}>
                    <div className='d-flex justify-content-start'>
                        <div className="bg-success text-white d-flex align-items-center justify-content-center" style={{borderRadius:60,width:60, height:60}} > 
                            { getUserName(r.userId).charAt(0).toUpperCase()} 
                        </div>
                        <div className='ms-2'>
                            <div > 
                                <span className='fw-bold'>{getUserName(r.userId) }</span>
                                <span className='ms-3 fst-italic text-success'>
                                    {r.remark !== null  ?
                                            <>
                                                Updated {r.remark}
                                            </>
                                        :
                                            <>
                                                {r.images !== null && r.images.length > 0 && "Add Image"}
                                                {r.attachments !== null && r.attachments.length > 0 && "Add Attachment"}
                                                {r.voiceNote !== null && "Add A voice Note" }
                                                {r.note !== null && "Add text note" }
                                                {r.hyperlink !== null && "Add a url " }
                                            </>

                                    }
                                    
                                </span>
                             </div>
                            <div className='' style={{fontSize:12}}>
                                <span className='me-2'><CalendarMonth /> {moment(r.created_at).format("DD-MMM YYYY") }</span>
                                <span className='me-2'><AccessTime /> {moment(r.created_at).format("hh:mm A") }</span>
                            </div>
                        </div>
                    </div>
                    
                    {r.remark === null &&
                    <div className=''> {/*my-3 border-5 pb-2 border-bottom */}
                        <div className='row'>
                            {r.images !== null && r.images.length > 0  &&
                                <div className='col-md-12'>
                                    <div style={{width:"100%" ,whiteSpace:"nowrap", overflowX:"auto"}}>
                                        {r.images.map(image=>
                                            <div className='card m-2 float-start'>
                                                <div className='card-body p-0'>
                                                    <Link target='_blank' to={image.url} ><img className='img-fluid' style={{width:400}}  alt="preview image" src={image.url} /></Link>
                                                </div>
                                                <div className='card-body' style={{width:400}}>
                                                    <p style={{textWrap:"auto"}}>{image.remark}</p>
                                                </div>
                                                {image.jsonData !== null &&
                                                    <JsonViewer jsonData={image.jsonData} />
                                                }
                                                <div className='card-footer'>
                                                <span className='float-start '>{image.fileTitle}</span>
                                                {authUser.id === r.userId &&
                                                    <span className='float-end '><button className='btn btn-outline-danger p-1' onClick={()=>removeActivityData("image",image.id)} > <Delete/> </button></span>
                                                }
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }

                            {r.attachments !== null && r.attachments.length > 0 &&
                                <>
                                    <div className='col-md-12'>
                                        {r.attachments.map(attachment=>
                                            <div className='card m-2 float-start'>
                                                <div className='card-body' style={{width:600}}>
                                                    <p>{attachment.remark}</p>
                                                </div>
                                                {attachment.jsonData !== null &&
                                                    <JsonViewer jsonData={attachment.jsonData} />
                                                }
                                                <div className='card-footer'>
                                                    {/* <AttachmentViewer url={attachment.url} /> */}
                                                    <Link target='_blank' to={attachment.url} className='m-2'> <AttachFile/> {attachment.fileTitle}</Link>
                                                    {authUser.id === r.userId &&
                                                        <span className='float-end '><button onClick={()=>removeActivityData("attachment",attachment.id)} className='btn btn-outline-danger p-1'><Delete/></button></span>
                                                    }
                                                </div>
                                            </div>
                                            
                                        )}
                                    </div>
                                </>
                            }

                            {r.voiceNote !== null &&
                                <>
                                    <div className='col-md-12'>
                                        
                                            <div className='card m-2 float-start'>
                                                <div className='card-body' style={{width:600}}>
                                                    <audio controls>
                                                        <source src={r.voiceNote.url} />
                                                    </audio>
                                                </div>
                                                <div className='card-footer'>
                                                    {authUser.id === r.userId &&
                                                        <span className='float-end '><button onClick={()=>removeActivityData("voiceNote",r.voiceNote.id)} className='btn btn-outline-danger p-1'><Delete/></button></span>
                                                    }
                                                </div>
                                            </div>
                                    </div>
                                </>
                            }

                            {r.note !== null &&
                                <>
                                    <div className='col-md-12'>
                                            <div className='card m-2 float-start'>
                                                <div className='card-body' style={{width:600}}>
                                                    <p>{r.note.note}</p>
                                                </div>
                                                <div className='card-footer'>
                                                    {authUser.id === r.userId &&
                                                        <span className='float-end '><button onClick={()=>removeActivityData("note",r.note.id)} className='btn btn-outline-danger p-1'><Delete/></button></span>
                                                    }
                                                </div>
                                            </div>
                                    </div>
                                </>
                            }

                            {r.hyperlink !== null &&
                                <>
                                    <div className='col-md-12'>
                                            <div className='card m-2 float-start'>
                                                <div className='card-body' style={{width:600}}>
                                                    <div><Link to={r.hyperlink.url} target='_blank' > {r.hyperlink.remark} </Link></div>
                                                </div>
                                                <div className='card-footer'>
                                                    {authUser.id === r.userId &&
                                                        <span className='float-end '><button onClick={()=>removeActivityData("hyperlink",r.hyperlink.id)} className='btn btn-outline-danger p-1'><Delete/></button></span>
                                                    }
                                                </div>
                                            </div>
                                    </div>
                                </>
                            }




                        </div>
                    </div>
                    }
                </div>
            )}
        </div>
  )
}

export default DocumentTimeline